"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Other"] = 0] = "Other";
    DocumentType[DocumentType["Image"] = 1] = "Image";
    DocumentType[DocumentType["PDF"] = 2] = "PDF";
    DocumentType[DocumentType["Excel"] = 3] = "Excel";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
//# sourceMappingURL=DocumentType.js.map